import React, { useEffect, useRef } from 'react';
import qrCode from 'qrcode';
import Logo from '../../components/Logo';
import getReferringBranchLink from '../../helpers/getReferringBranchLink';
import { AGENT_SIGNUP_BRANCH_LINK } from '../../constants/urls';

export default function SignupPage() {
  const qrCanvasRef = useRef(null);

  useEffect(() => {
    async function generateQrCode() {
      const referringBranchLink = await getReferringBranchLink();
      qrCode.toCanvas(
        qrCanvasRef.current,
        referringBranchLink || AGENT_SIGNUP_BRANCH_LINK,
        { width: 200, margin: 0 },
      );
    }
    generateQrCode();
  }, []);

  return (
    <div className="p-8 md:p-16 flex flex-col items-start justify-start h-screen">
      <div className="flex flex-row items-center mb-12">
        <Logo size={64} />
        <h1 className={'ml-2'}>TopHouse</h1>
      </div>
      <p>
        Scan this special QR Code with your phone{`'`}s camera to create an
        account
      </p>
      <p>You will first be taken to the app store if you do not have the app</p>
      <canvas ref={qrCanvasRef} className={'mt-8'} />
    </div>
  );
}
